import { AppRouteObject } from "./types";
import { routeRequiresOrderNumber } from "./orderNumberRouting";

////Not Gonna Lie, Generated By Claude and I didn't go through every single line
export const extractDirectoryRoutes = (routesList: AppRouteObject[]): AppRouteObject[] => {
  const result: AppRouteObject[] = [];

  const generateTitle = (path: string): string => {
    const pathWithoutParams = path.split("/").filter((segment) => segment && !segment.startsWith(":"));

    if (pathWithoutParams.length === 0) {
      return "Home";
    }

    const title = pathWithoutParams
      .map((segment) =>
        segment
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      )
      .join(" ");

    return title;
  };

  const traverse = (routes: AppRouteObject[], parentPath = ""): void => {
    routes.forEach((route) => {
      if ((route.element && (route.element as any)?.type?.name === "Navigate") || (route.index && !route.path)) {
        return;
      }

      let fullPath = "";
      const routePath = route.path || "";

      if (routePath.startsWith("/")) {
        fullPath = routePath;
      } else if (parentPath && routePath) {
        fullPath = `${parentPath}/${routePath}`.replace(/\/+/g, "/");
      } else {
        fullPath = parentPath || routePath;
      }

      fullPath = fullPath.replace(/\/+$/, "");

      if (fullPath && !fullPath.startsWith("/")) {
        fullPath = "/" + fullPath;
      }

      if (fullPath) {
        const hasParams = fullPath.includes(":");
        const promptsForOrderNumber = routeRequiresOrderNumber({ ...route, path: fullPath });

        if (!hasParams || route.title || promptsForOrderNumber) {
          if (route.showInDirectory !== false) {
            result.push({
              ...route,
              path: fullPath,
              title: route.title || generateTitle(fullPath)
            });
          }
        }
      }

      if (route.children && route.children.length > 0) {
        traverse(route.children as AppRouteObject[], fullPath);
      }
    });
  };

  traverse(routesList);

  const uniqueRoutes = result.reduce<AppRouteObject[]>((acc, route) => {
    if (!acc.some((r) => r.path === route.path)) {
      acc.push(route);
    }
    return acc;
  }, []);

  return uniqueRoutes.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
};
